import { render, staticRenderFns } from "./SpotlightSection.vue?vue&type=template&id=4f0adfda&scoped=true&"
import script from "./SpotlightSection.vue?vue&type=script&lang=js&"
export * from "./SpotlightSection.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightSection.vue?vue&type=style&index=0&id=4f0adfda&scoped=true&lang=css&"
import style1 from "./SpotlightSection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0adfda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VIcon})
